import React from "react";
import "./styles/styles.css";
import "../../styles/global.css";

const ToggleSwitch = ({ label, value, setIsOn }) => {
  const isOn = value === true;

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };

  return (
    <div className="flex-direction-row gap-12 toggle-switch-wrapper">
      <label className="font-12 inria-sans-700">{label}</label>
      <div
        className={`toggle-switch ${isOn ? "on" : "off"}`}
        onClick={toggleSwitch}
      >
        <div className="flex-direction-row items-center justify-center toggle-circle">
          <p className={`${isOn ? "on" : "off"}`}>{isOn ? "✓" : "✕"}</p>
        </div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
